var React = require('react');

function Minus (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M11.8125 6.8466V5.17725H0.1875V6.8466H11.8125Z","fill":"#F7D18F"}));
}

Minus.defaultProps = {"width":"12","height":"12","viewBox":"0 0 12 12","fill":"none"};

module.exports = Minus;

Minus.default = Minus;
